import type { ReactNode, Ref } from "react";
import type { TextProps as AriaTextProps } from "react-aria-components";
import { Text as AriaText } from "react-aria-components";
import { cx } from "@/utils/cx";

interface HintTextProps extends AriaTextProps {
	/** Indicates that the hint text is an error message. */
	isInvalid?: boolean;
	/** Accepted by callers; styling is size-invariant. */
	size?: "sm" | "md";
	ref?: Ref<HTMLElement>;
	children: ReactNode;
}

export const HintText = ({ isInvalid, className, ...props }: HintTextProps) => {
	return (
		<AriaText
			{...props}
			slot={isInvalid ? "errorMessage" : "description"}
			className={cx(
				// Figma Input hint: Text sm/Medium, text-secondary; error → text-error-primary
				"text-sm font-medium text-secondary",

				isInvalid && "text-error-primary",
				"group-invalid:text-error-primary",

				className,
			)}
		/>
	);
};

HintText.displayName = "HintText";
